import { getDashboardDetailsActions } from "./action";

const initialState = {
  dashboardDetails: null,
  error: null,
  loading: false,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case getDashboardDetailsActions.GET_DASHBOARD_DETAILS_SUCCESS:
      return {
        ...state,
        dashboardDetails: action.payload,
        error: null,
        loading: false,
      };

    case getDashboardDetailsActions.GET_DASHBOARD_DETAILS_ERROR:
      return {
        ...state,
        error: action.payload,
        dashboardDetails: null,
        loading: false,
      };

    default:
      return state;
  }
};

export default dashboardReducer;
